export const queryAllData = `
    id
    name {
      firstFull
      gender
    }
`;

export const queryCareLevelData = `
  careLevels {
    level
    date
    provisional
  }
`;

export const queryResidentHeaderFlags = `
  isDyingPhase
  hasInfectiousDisease
  hasMultiResistantGerm
  hasCognitiveLimitations
  hasMedicationAdministration
  careLevel
`;
